import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Panel from 'beam/dist/Panel'
import withStyles from 'beam/dist/styles'
import BeamIcon from 'beam/dist/BeamIcon'

import DesktopContent from './DesktopContent'
import ErrorBoundary from '../ErrorBoundary'

const dataTestIdPrefix = 'App-Recordings-MediaPlayer-DesktopPanel-'

const styles = theme => ({
  panelRoot: {
    boxShadow: 'none',
  },
  panelBody: {
    padding: theme.spacing(1, 0),
  },
})

const DesktopPanel = props => {
  const { t, classes, ...contentProps } = props

  return (
    <Panel
      titleIcon={<BeamIcon>DesktopMacDashboard</BeamIcon>}
      title={t('desktop')}
      classes={{ root: classes.panelRoot, body: classes.panelBody }}
      dense
      variant="light"
      dataTestId={`${dataTestIdPrefix}panel`}
      headerTestId={`${dataTestIdPrefix}panel-heading`}
    >
      <ErrorBoundary key={contentProps.ccrid}>
        <DesktopContent {...contentProps} />
      </ErrorBoundary>
    </Panel>
  )
}

DesktopPanel.propTypes = {
  /** Provided by `react-i18next.translate` decorator */
  t: PropTypes.func.isRequired,
  /** Provided by `beam/dist/styles.withSytles` decorator */
  classes: PropTypes.object.isRequired,
  ccrid: PropTypes.number.isRequired,
}

export { DesktopPanel as UnstyledDesktopPanel }
export default withTranslation()(withStyles(styles, { withTheme: true })(DesktopPanel))
